<template>
		<div>
			<OtherRaports
				:key="other_raports_key"
				:make_request_for_data="false"
				:make_reply="true"
				:pre_inited_data="reports"
				:color_by_status="color"
				:ismyreports="true"
			/>
			<BaseDefaultError v-if="haveDataOneRaportCategory()" :message="no_data_raport" />
		</div>
</template>

<script>
import OtherRaports from '../other_raports/OtherRaports';
export default {
	name: 'ViewMyReport',
	props: {
		reports_coming_from_status: {
			type: [Array],
		},
		color_by_status: {
			type: [String],
		},
	},
	components: {
		OtherRaports,
	},
	data() {
		return {
			color: this.color_by_status,
			reports: this.reports_coming_from_status,
			other_raports_key: 20,
			no_data_raport: 'no_data_raport',
		};
	},
	mounted() {
		this.$store.state.active_loader = false;
		this.saveMyReportLocalStorage();
	},

	methods: {
		saveColorLocalStorage() {
			if (localStorage.color == '') {
				this.color = this.color_by_status;
				localStorage.color = this.color;
			} else {
				this.color = localStorage.color;
			}
		},
		haveDataOneRaportCategory() {
			return this.reports != undefined ? this.reports.length == 0 : false;
		},
		saveRaportStatusLocalStorage() {
			// ToDo Review This
			if (localStorage.reports == '') {
				localStorage.reports = JSON.stringify(this.reports);
			} else {
				this.reports = JSON.parse(localStorage.reports);
			}
		},
		saveMyReportLocalStorage() {
			this.other_raports_key += 1;
			this.saveColorLocalStorage();
			this.saveRaportStatusLocalStorage();
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>

<style scoped lang="scss" src="./ViewMyReport.scss"></style>
